module.exports = __webpack_public_path__ + "img/fruit4.e00ca11b.jpg";